(function (Drupal, Swiper) {
  Drupal.behaviors.photoGallery = {
    attach(context) {
      const resizeImageAlt = () => {
        const slides = document.querySelectorAll('.photo-gallery .swiper-slide');
        slides.forEach((slide, index) => {
          slide.querySelector('.image-alt').setAttribute("style","width:" + slide.querySelector('img').width + "px")
        });
      }

      new Swiper('.photo-gallery .swiper', {
        spaceBetween: 20,
        slidesPerView: "auto",
        slidesPerGroup: 1,
        pagination: {
          el: ".swiper-pagination",
          type: "progressbar",
        },
        navigation: {
          nextEl: ".btn-next",
          prevEl: ".btn-prev",
        },
        on: {
          afterInit: () => resizeImageAlt(),
          resize: () => resizeImageAlt(),
        }
      });
    },
  };
})(Drupal, Swiper);
